import { connect } from 'react-redux';

import { getTimeslots, getMeals, getDrinks, resetMeta, resetPage, createOrder, getMealCustomizations, clearMealCustomizations, getDrinkCustomizations, clearDrinkCustomizations } from '../../actions/BookingPage';

import BookingPage from './BookingPage';

const mapsStateToProps = state => ({
	bookingPageProps: state.bookingPageReducer
});

const mapsDispatchToProps = dispatch => ({
	getTimeslots(options) {
		dispatch(getTimeslots(options));
	},
	getMeals(options) {
		dispatch(getMeals(options));
	},
	getDrinks() {
		dispatch(getDrinks());
	},
	getMealCustomizations(options) {
		dispatch(getMealCustomizations(options));
	},
	getDrinkCustomizations(options) {
		dispatch(getDrinkCustomizations(options));
	},
	clearMealCustomizations() {
		dispatch(clearMealCustomizations());
	},
	clearDrinkCustomizations() {
		dispatch(clearDrinkCustomizations());
	},
	resetPage() {
		dispatch(resetPage());
	},
	resetMeta() {
		dispatch(resetMeta());
	},
	createOrder(body) {
		return dispatch(createOrder(body));
	}
});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(BookingPage);
